import React from 'react'

export default class IconsAlignTop extends React.Component {
    render() {
        let color = '#C8C5FE'
        if (this.props.color) color = this.props.color

        return (
            <svg
                width='16'
                height='16'
                viewBox='0 0 16 16'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
                style={this.props.style}
            >
                <g>
                    <path
                        d='M5.33268 4H3.99935C3.26297 4 2.66602 4.59695 2.66602 5.33333V13.3333C2.66602 14.0697 3.26297 14.6667 3.99935 14.6667H5.33268C6.06906 14.6667 6.66602 14.0697 6.66602 13.3333V5.33333C6.66602 4.59695 6.06906 4 5.33268 4Z'
                        stroke={color}
                        strokeWidth='1.25'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M12.0007 4H10.6673C9.93094 4 9.33398 4.59695 9.33398 5.33333V8.66667C9.33398 9.40305 9.93094 10 10.6673 10H12.0007C12.737 10 13.334 9.40305 13.334 8.66667V5.33333C13.334 4.59695 12.737 4 12.0007 4Z'
                        stroke={color}
                        strokeWidth='1.25'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M14.6673 1.33337H1.33398'
                        stroke={color}
                        strokeWidth='1.25'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                </g>
            </svg>
        )
    }
}
